import { TransactionRequest } from "../transaction-request";

// request the status of a previous transaction
export class TransactionStatusRequest extends TransactionRequest {
  constructor(input: { SessionId: string }) {
    super();
    this.SessionId = input.SessionId;
  }

  // The session ID of the transaction to be queried.
  SessionId: string;
}
